<div class="error-message-container">
  <ng-container *ngIf="validationMessages">
    <span class="error-message-left" *ngFor="let message of validationMessages">
      {{ message.message | msg : { value: message.value } | async }}
      <br />
    </span>
  </ng-container>
</div>
